/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import React from "react"
import "./src/styles/typo.scss"
import "./src/styles/globals.scss"
import "./src/styles/layout.scss"
import Provider from "./src/provider"
import PageWrapper from "./src/components/templates/PageWrapper"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
export const wrapPageElement = ({ element, props }) => {
  return <PageWrapper props={props}>{element}</PageWrapper>
}

export const onRouteUpdate = () => {
  // Remove scroll animations on route change
  document.body.classList.remove("theme--dark")

  if (!ScrollTrigger?.getAll()?.length) return

  ScrollTrigger.getAll().forEach(trigger => {
    trigger.kill()
  })
}
